"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("card/base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _class, _descriptor, _descriptor2, _temp;

var RewardCard = (_class = (_temp =
/*#__PURE__*/
function (_Card) {
  babelHelpers.inherits(RewardCard, _Card);

  function RewardCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, RewardCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(RewardCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "rewardTime", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "rewardSummary", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(RewardCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "calendar_today"
      }), _react.default.createElement("div", {
        className: "date"
      }, new Date(1000 * this.rewardTime).format('F j, Y')));
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("h3", null, this.objectTitle), _react.default.createElement("p", null, this.rewardSummary));
    }
  }]);
  return RewardCard;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rewardTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rewardSummary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = RewardCard;